import React, {Component} from "react";

class Spinner extends Component {

	render() {
		return (
			<div className="make_modal">
				<div className="loading_spinner" />
			</div>
		);
	}

}

export default Spinner;
